import { DEFAULT_USER_SETTINGS } from './chunk-UJBTIEC5.mjs';

// src/user-settings/parse.ts
var isRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
var parseUserSettings = (raw) => {
  const blob = isRecord(raw) ? raw : {};
  const watch = isRecord(blob.watch) ? blob.watch : {};
  return {
    watch: {
      standaloneMode: typeof watch.standaloneMode === "boolean" ? watch.standaloneMode : DEFAULT_USER_SETTINGS.watch.standaloneMode
    }
  };
};

export { parseUserSettings };
//# sourceMappingURL=chunk-EHPC6J6S.mjs.map
//# sourceMappingURL=chunk-EHPC6J6S.mjs.map